import React, { useMemo } from 'react'
import { useRedirectQuery } from '@graphql/queries/__generated__/redirect.generated'
import { Redirect } from 'react-router-dom'
import { PAGE_404_URL } from '../urls'
import _ from 'lodash'

interface Props {
  pathname: string
  search: string
}

const MaybeRedirect: React.FC<Props> = ({ pathname, search }) => {
  const isImage = pathname.includes('image/catalog')

  const slug = useMemo(() => {
    const isImage = pathname.includes('image/catalog')
    if (isImage) {
      return pathname.slice(1)
    }
    return search.slice(1) || _.last(pathname.split('/').filter(Boolean))
  }, [pathname, search])

  const { data, loading } = useRedirectQuery({ variables: { slug }, fetchPolicy: 'network-only' })
  if (!loading && data?.redirect) {
    if (isImage) {
      window.location.pathname = data.redirect.newPath.startsWith('/')
        ? data.redirect.newPath
        : '/' + data.redirect.newPath
      return null
    }
    return <Redirect to={data.redirect.newPath} />
  }
  if (loading) {
    return null
  }
  return <Redirect to={PAGE_404_URL} />
}

export default MaybeRedirect
